import Header from './components/Header';
import HeroSection from './components/HeroSection';
import TopicsSection from './components/TopicsSection';
import UpdatesSection from './components/UpdatesSection';
import CommentsSection from './components/CommentsSection';
import ContactSection from './components/ContactSection';
import RankingSection from './components/RankingSection';
import FeaturesSection from './components/FeaturesSection';
import CarouselSection from './components/CarouselSection';
import AboutSection from './components/AboutSection';
import FaqSection from './components/FaqSection';
import CardsSection from './components/CardsSection';
import MediaSection from './components/MediaSection';
import AppSection from './components/AppSection';
import IndexSection from './components/IndexSection';
import Footer from './components/Footer';

export default function Home() {
  return (
    <div className="min-h-screen bg-background-50">
      <Header />
      <main>
        <HeroSection />
        <TopicsSection />
        <UpdatesSection />
        <CommentsSection />
        <ContactSection />
        <RankingSection />
        <FeaturesSection />
        <CarouselSection />
        <AboutSection />
        <FaqSection />
        <CardsSection />
        <MediaSection />
        <AppSection />
        <IndexSection />
      </main>
      <Footer />
    </div>
  );
}